export default __webpack_public_path__ + "static/media/GD.440b7bfa.svg";